import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, { onCancel: _ctx.closeModal }, {
    default: _withCtx(() => [
      _createVNode(_component_ModalCard, {
        onCancel: _ctx.closeModal,
        activeValidate: !!(_ctx.firstname && _ctx.lastname && /\S+@\S+\.\S+/.test(_ctx.email)),
        headerTitle: _ctx.$t(`contact.form.title.${_ctx.contact === undefined ? 'new' : 'edit'}`),
        onConfirm: _ctx.confirm
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('contact.form.subtitle')), 1),
            _createVNode(_component_TextInput, {
              class: "input",
              modelValue: _ctx.firstname,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstname) = $event)),
              label: _ctx.$t('contact.form.firstname')
            }, null, 8, ["modelValue", "label"]),
            _createVNode(_component_TextInput, {
              class: "input",
              modelValue: _ctx.lastname,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastname) = $event)),
              label: _ctx.$t('contact.form.lastname')
            }, null, 8, ["modelValue", "label"]),
            (_ctx.isPhone)
              ? (_openBlock(), _createBlock(_component_TextInput, {
                  key: 0,
                  class: "input",
                  modelValue: _ctx.phone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phone) = $event)),
                  label: _ctx.$t('contact.form.phone')
                }, null, 8, ["modelValue", "label"]))
              : (_openBlock(), _createBlock(_component_TextInput, {
                  key: 1,
                  class: "input",
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
                  label: _ctx.$t('contact.form.mail')
                }, null, 8, ["modelValue", "label"]))
          ])
        ]),
        _: 1
      }, 8, ["onCancel", "activeValidate", "headerTitle", "onConfirm"])
    ]),
    _: 1
  }, 8, ["onCancel"]))
}